import { Button, ButtonVariant } from '@base-components/Button';
import OutOfStockForm from '@modules/PDP/components/OutOfStockForm/OutOfStockForm';
import { PaymentOptions } from '@components/PaymentOptions/PaymentOptions';

import styles from './PaymentSummary.module.scss';

export const PaymentSummary = ({
  paymentOptions,
  isDemandTestCategory,
  mainItem,
  addToCartText,
  handleAddToCart,
  buttonDisabled,
  cartId,
  additionalServicesRecurringSum,
  monthlyFeeText,
  oneTimeFee,
  selectedMainProductPricing,
  currencyFormatter,
  additionalServicesOneTimeSum,
  isFinancePlan,
  financingDescription,
}) => {
  return (
    <>
      <div className={styles.pricesContainer}>
        {!isFinancePlan && (
          <div className={styles.deliveryFeeContainer}>
            <span className={styles.deliveryFeeContainerText}>{oneTimeFee}</span>
            <span
              className={styles.deliveryFeeContainerValue}
              data-deposit-amount={selectedMainProductPricing.oneTimeAmount}
            >
              {currencyFormatter({ price: selectedMainProductPricing.oneTimeAmount + additionalServicesOneTimeSum })}
            </span>
          </div>
        )}
        {isFinancePlan && <div className={styles.summaryLine}></div>}

        <div className={styles.monthlyFeeContainer}>
          <span className={styles.monthlyFeeContainerText}>{monthlyFeeText}</span>
          <span
            className={styles.monthlyFeeContainerValue}
            data-monthly-price={selectedMainProductPricing?.recurringAmount}
          >
            {currencyFormatter({
              price: selectedMainProductPricing?.recurringAmount + additionalServicesRecurringSum,
            }) || '-'}
          </span>
        </div>
      </div>

      <footer className={styles.footer}>
        {isFinancePlan && financingDescription && (
          <div className={styles.additionalDescription}>{financingDescription}</div>
        )}

        {selectedMainProductPricing.isAvailable ? (
          <Button
            isFullWidth
            as="button"
            variant={ButtonVariant.Basic}
            disabled={!selectedMainProductPricing || !cartId || buttonDisabled}
            onClick={handleAddToCart}
            dataAttribute={{ 'data-cta-text': addToCartText, 'data-cta-position': 'pdp-add-to-cart' }}
          >
            {addToCartText}
          </Button>
        ) : (
          <OutOfStockForm
            vib={mainItem.contentSlug.toUpperCase()}
            className={styles.outOfStockForm}
            additionalServices={{}}
            isDemandTestCategory={isDemandTestCategory}
            url=""
          />
        )}

        {!isFinancePlan && (
          <div className={styles.paymentsContainer}>
            <PaymentOptions options={paymentOptions} />
          </div>
        )}
      </footer>
    </>
  );
};
